// extracted by mini-css-extract-plugin
export default {"container":"DataAmination_container__1lMPq"};